<template>
  <label
    :class="[
      'checkbox-image',
      { 'checkbox-image--checked': isChecked, 'checkbox-image--error': error, 'checkbox-image--disabled': disabled },
    ]"
  >
    <input
      class="visually-hidden checkbox-image__input"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      type="checkbox"
      @change="check"
    />

    <span v-if="image" class="checkbox-image__image-wrap">
      <img :src="image" :alt="label" class="checkbox-image__image" />
      <span class="checkbox-image__state">
        <svg class="checkbox-image__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </span>

    <span class="checkbox-image__content">
      <span v-if="label" class="checkbox-image__label" @click.stop>{{ label }}</span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'CheckboxImage',
  emits: ['input', 'change'],
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    checkedValue: {
      type: [String, Number, Boolean],
      required: true,
    },
    uncheckedValue: {
      default: null,
    },
    checked: {
      type: Boolean,
      default: null,
    },
    image: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      if (this.checked !== null) {
        return this.checked
      }

      return this.value === this.checkedValue
    },
  },
  methods: {
    check(event) {
      const value = event.target.checked ? this.checkedValue : this.uncheckedValue

      this.$emit('input', value)

      if (this.checked !== null) {
        this.$emit('change', value)
      }
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.checkbox-image
  display: flex
  flex-direction: column
  gap: 12px
  flex: 1

  &--checked
    .checkbox-image
      &__state
        background: #f5f5fa
        border: var(--field-border-width, 1px) solid #f5f5fa

      &__icon
        opacity: 1

  &--disabled
    opacity: var(--field-opacity-disabled, 0.7)
    pointer-events: none

  &--error
    .checkbox-image
      &__state
        border-color: var(--field-error-border-color, $error)

  &__image-wrap
    position: relative
    width: 100%
    height: 144px
    overflow: hidden
    border-radius: 6px

    &:after
      content: ''
      position: absolute
      left: 0
      bottom: 0
      width: 100%
      height: 52px
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)
      border-radius: 0 0 6px 6px

  &__image
    display: block
    width: 100%
    height: 100%
    object-fit: cover

  &__state
    position: absolute
    right: 16px
    bottom: 16px
    z-index: 2
    width: 24px
    height: 24px
    border-radius: 4px
    border: var(--field-border-width, 1px) solid #e7e7e8
    background: transparent
    transition: all .2s

  &__icon
    position: absolute
    right: 1px
    bottom: 1px
    opacity: 0
    z-index: 2
    color: $cyan
    transition: opacity .2s

  &__label
    color: $white
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/CheckboxImage.vue